import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postMobile3, postMobileA1 } from "./LandingPageCRUD";
import { landingPageSlice } from "./LandingPageSlice";

const { actions } = landingPageSlice;

export const getLandingPageList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobile3(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.landingPageListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: getLandingPageList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const getEs51LandingPageList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobileA1(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.es51LandingPageListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: getEs51LandingPageList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
